import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import EditAmeniitesPageNew from "../../components/Amenities/AddAmenitiesPageNew";



const EditAmenitiesPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="Amenities" link2="/amenities" title="Edit Amenities" />

        {/* AddUserLayer */}
        <EditAmeniitesPageNew />


      </MasterLayout>
    </>
  );
};

export default EditAmenitiesPage;
